<div class="wrap">
  <div class="arrows">
    <app-svg-icon [name]="'down'" color="color-on-primary"></app-svg-icon>
    <app-svg-icon [name]="'down'" color="color-on-primary"></app-svg-icon>
  </div>
  <div class="text">
    {{ "@components.scrollFloatHint.text" | translate }}
  </div>
  <div class="arrows">
    <app-svg-icon [name]="'down'" color="color-on-primary"></app-svg-icon>
    <app-svg-icon [name]="'down'" color="color-on-primary"></app-svg-icon>
  </div>
</div>
